import { CopyOperationsLogTable } from "@/components/copy-operations/CopyOperationsLogTable";
import { PageHeader } from "@/components/shared/page-header";

export function CopyOperationsLogPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Copy Operations Log"
        description="Every Contract copy initiated from Contract Search — staged, posted, or failed."
      />
      <CopyOperationsLogTable />
    </div>
  );
}
